export default __webpack_public_path__ + "static/media/water.73dc4bb3.jpg";